import React from 'react';

import { TaskDisplay, TaskType } from '@centecomm/portal-service';

import SubscribeToAlertSystem from './SubscribeToAlertSystem';
import LeasingApplicationAlert from './LeasingApplicationAlert';
import TaskLink from './TaskLink';

interface Properties {
    task: TaskDisplay;
}

const TaskSectionDetails: React.FC<Properties> = ({ task }) => {
    switch (task.type) {
        case TaskType.CompleteLeasingApplication:
            return <LeasingApplicationAlert task={task} />;
        case TaskType.SubscribeToAlerts:
            return <SubscribeToAlertSystem task={task} />;
        default:
            break;
    }

    return <TaskLink task={task} />;
};

export default TaskSectionDetails;
